/**
 * Blog filters
 */
var component_blog_filters = function(args) {

  // setup args
  var filters = args.blog_filter; // match this to $menu-visible SASS variable
  let resetBtn = filters.querySelector('.blog-filters__reset-filters');

  if (filters) {
    (function($) {
      $(document).on('facetwp-loaded', function() {
        filters.querySelector('.blog-filters__results-count').innerHTML = FWP.settings.pager.total_rows + ' ' + translations.str_results;

        if (FWP.facets.categories.length >= 1) {
          resetBtn.classList.add('visible');
        } else {
          resetBtn.classList.remove('visible');
        }

        // Scroll to top (pagination)
        if (FWP.loaded) {
          $('html, body').animate({
              scrollTop: $('.facetwp-template').offset().top - $('.blog-filters').height() * 2
          }, 500);
        }
      });
    })(jQuery);
  }

  // Add proper aria-labels to pagination next and previous links
  document.addEventListener('DOMContentLoaded', function() {
    let pagination = document.querySelector('.numeric-navigation__facet-wp-pagination');

    if (pagination) {
      let next = pagination.querySelector('.facetwp-page.next');
      let previous = pagination.querySelector('.facetwp-page.prev');
      if (next) {
        next.setAttribute('aria-label', translations.str_next);
      }
      if (previous) {
        previous.setAttribute('aria-label', translations.str_previous);
      }
    }
  });

  // make the call chainable
  return this;

};

